import { W as WuiThumbnail$1, d as defineCustomElement$1 } from './p-HDOuhNRM.js';

const WuiThumbnail = WuiThumbnail$1;
const defineCustomElement = defineCustomElement$1;

export { WuiThumbnail, defineCustomElement };
